import useLocalization from '../../../../../hooks/useLocalization';

const CODES = {
    minutes: 'epic.affiliate.common.time.minutes',
    hours: 'epic.affiliate.common.time.hour'
};

/*
 * Value should be in minutes
 * returns string with format: 1h:1m
 * */
export type UseDurationFormatter = (value: number) => string;

const useDurationFormatter = (): UseDurationFormatter => {
    const getMessage = useLocalization();

    return value => {
        const hours = Math.trunc(value / 60);
        const minutes = value % 60;

        return [
            hours ? getMessage(CODES.hours, [hours]) : '',
            minutes ? getMessage(CODES.minutes, [minutes]) : ''
        ]
            .join(' ')
            .trim();
    };
};

export default useDurationFormatter;
